import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {SafePipe} from "./safe.pipe";
import {MyInhertLinkDirective} from "./my-inhert-link.directive";
import {RunScriptsDirective} from "./run-scripts.directive";
import {HtmlUtilsService} from "./html-utils.service";
import { DeferLoadDirective } from './defer-load.directive';
import {DetectBrowserService} from "./detect-browser/detect-browser.service";

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    SafePipe,
    MyInhertLinkDirective,
    RunScriptsDirective,
    DeferLoadDirective,
  ],
  providers: [
    HtmlUtilsService,
    DetectBrowserService
  ],
  exports: [
    SafePipe,
    MyInhertLinkDirective,
    RunScriptsDirective,
    DeferLoadDirective
  ]
})
export class HtmlUtilsModule { }
